module.exports = __webpack_public_path__ + "media/images/Graham_Wheeler-7f5183c3835d5e4f3d6ee7dbe495ff16.jpg";